<template>
  <div class="container-fluid h-100">
    <div class="row">
      <div class="col-12">
        <h1 class="h4 mt-1">Indicadores</h1>
      </div>
    </div>
    <div class="row pt-1">
      <div class="col-sm-12">
        <div class="card w-100">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <portalEmpresa
                  :options="DadosPortalEmpresa"
                  v-model="DadosFiltro.DadosSelecionadosPortalEmpresa"
                  :requiredportal="true"
                  :requiredempresa="true"
                />
              </div>
            </div>

            <div class="row mt-2 d-flex">
              <div class="col-sm-4">
                <filtroAnoMes v-model="DadosFiltro.RangeDatas" />
              </div>

              <div class="col-sm-3 d-flex align-items-end pl-0">
                <div class="custom-control custom-checkbox">
                  <input
                    class="custom-control-input"
                    id="controleLoteCompraVenda"
                    type="checkbox"
                    v-model="DadosFiltro.VisualizarApenasKPIComMetas"
                  />
                  <label
                    class="custom-control-label text-nowrap pl-4"
                    for="controleLoteCompraVenda"
                  >Visualizar apenas KPI's com metas</label>
                </div>
              </div>

              <div class="col-sm-5 d-flex align-items-end justify-content-end">
                <button type="submit" class="btn btn-primary" v-on:click="filtrarCuboKPI">Filtrar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-show="DadosRelatorios.Cubos.length === 0"
      style="height: calc(100% - 235px);"
    >
      <div class="col-sm-12 pt-2 d-flex align-items-stretch justify-content-stretch">
        <div
          class="card text-center h-100 w-100 d-flex align-items-center justify-content-center font-size-small"
        >
          <i class="fa fa-exclamation text-primary" style="font-size: 40px;"></i>
          <h1
            class="mt-2 text-uppercase"
            style="font-size: 22px;"
          >Selecione os filtros desejados e clique em filtrar</h1>
        </div>
      </div>
    </div>
    <div class="row fixedElementw" v-show="DadosRelatorios.Cubos.length > 0">
      <div class="col-sm-12 pt-2 d-flex align-items-stretch justify-content-stretch">
        <div class="card text-center h-100 w-100">
          <div class="card-body">
            <div class="row d-flex d-flex align-items-center">
              <div class="col-12">
                <div
                  class="dia text-center d-flex align-items-center justify-content-center"
                  style="width: 27%;"
                >Dias</div>
                <div
                  class="dia"
                  :title="titleDiaSemana(index+1)"
                  v-for="(dia, index) in DadosRelatorios.Dias"
                  :key="index"
                >
                  {{dia.substring(0,1)}}
                  <br />
                  {{index+1}}
                </div>
                <div
                  class="dia d-flex align-items-center justify-content-center"
                  style="width: 4%;"
                >Total</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-show="DadosRelatorios.Cubos.length > 0">
      <div
        class="col-sm-12 pt-2 d-flex align-items-stretch justify-content-stretch"
        v-for="cuboKPI in DadosRelatorios.Cubos"
        :key="cuboKPI.nomeCubo"
      >
        <div class="card text-left w-100">
          <div class="card-title mb-0 pt-2 pl-2 font-weight-bold text-uppercase text-primary">
            <h1 class="mb-1">{{cuboKPI.nomeCubo}}</h1>
          </div>
          <div class="card-body pt-2">
            <div
              class="row d-flex d-flex align-items-center"
              v-for="(kpi, indexKpi) in cuboKPI.listaKpis"
              :key="indexKpi"
            >
              <div
                class="col-12 d-flex align-items-stretch"
                v-if="kpi[0].VisualizarApenasKPIComMetas"
              >
                <div class="dia-cubo text-left pl-2" style="width: 27%;">
                  <div class="row">
                    <div
                      class="col-1 d-flex align-items-center"
                      v-on:click="adicionarRemoverDashboard(kpi[0])"
                    >
                      <div v-if="kpi[0].JaAdicionadoAoDashboard">
                        <div class="icon icon-minus"></div>
                      </div>
                      <div v-if="!kpi[0].JaAdicionadoAoDashboard">
                        <div class="icon icon-plus"></div>
                      </div>
                    </div>
                    <div
                      class="col-1 d-flex align-items-center"
                      v-on:click="abrirModalGrafico(kpi)"
                    >
                      <i :class="{'cursor-pointer': true, 'fas fa-chart-line': true}"></i>
                    </div>
                    <div class="col-9 pr-1">
                      <div class="text-uppercase font-weight-bold">{{kpi[0].Name}}</div>
                    </div>
                  </div>
                </div>
                <div
                  class="dia-cubo d-flex justify-content-center align-items-center"
                  v-for="(diaKPI, indexDiaKpi) in kpi"
                  :key="indexDiaKpi"
                  v-tooltip="{content: diaKPI.TitleDiaSemana, html: true }"
                >
                  <div :class="diaKPI.ClassComBola">
                    <div v-html="diaKPI.IconCheck"></div>
                  </div>
                </div>
                <div
                  class="dia-cubo d-flex justify-content-center align-items-center"
                  style="width: 4%;"
                  v-tooltip="{content: kpi.TitleDiaSemanaTotalizador, html: true }"
                >
                  <div :class="kpi.ClassComBolaTotalizador"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modalGraficoKpi">
      <div class="modal-dialog modal-dialog-centered modal-dialog-grafico">
        <div class="modal-content modal-content-grafico">
          <div class="modal-header cabecalho-modal-customizado-lmx">
            <h5 class="modal-title text-uppercase">{{DadosGrafico.TitleModalGrafico}}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="modais.ModalGraficoKpi.hide()"
            >&times;</button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <GChart
                  type="LineChart"
                  :data="DadosGrafico.chartData"
                  :options="DadosGrafico.chartOptions"
                  :events="DadosGrafico.chartEventsGrafico"
                  @ready="onChartReady"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="modais.ModalGraficoKpi.hide()">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-dialog-grafico {
  width: 90%;
  padding-left: 51px;
}

@media (max-width: 576px) {
  .modal-dialog-grafico {
    width: auto;
  }
}

@media (min-width: 576px) {
  .modal-dialog-grafico {
    max-width: none;
  }
}

.cabecalho-modal-customizado-lmx {
  background-color: #5b2e90 !important;
  color: white !important;
  padding: 0.6rem !important;
}

.cabecalho-modal-customizado-lmx button {
  color: #fff !important;
}

.rodape-modal-customizado-lmx {
  padding: 0.6rem !important;
}

.icone-lmx-book {
  font-size: 2.5rem;
  color: #5b2e90;
}

.dia {
  height: 55px;
  width: 2.2%;
  float: left;
  border: 1px solid #ddd;
  text-align: center;
  padding-top: 5px;
  font-weight: bold;
  background-color: rgb(239, 239, 239);
}

.dia-cubo {
  width: 2.2%;
  float: left;
  border: 1px solid #ddd;
  text-align: center;
  padding-top: 5px;
  font-weight: bold;
  background-color: #fff;
}

.form-row {
  margin-bottom: 0.5rem;
}

.fixedElement {
  position: sticky;
  top: -10px;
  z-index: 3;
}

.dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}

.dot-verde {
  background-color: green;
}

.dot-vermelho {
  background-color: red;
}

.dot-amarelo {
  background-color: yellow;
}

.dot-preto {
  background-color: black;
}

.icon {
  position: relative;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.icon-minus {
  background-color: #000;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  width: 16px;
  height: 16px;
  position: relative;
  top: 0;
  left: 0;
}

.icon-minus:after {
  background-color: #fff;
  width: 8px;
  height: 2px;
  border-radius: 1px;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  position: absolute;
  top: 7px;
  left: 3.5px;
  z-index: 4;
  content: "";
}

.icon-plus {
  background-color: #000;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  width: 16px;
  height: 16px;
  position: relative;
  top: 0;
  left: 0;
}
.icon-plus:after {
  background-color: #fff;
  width: 8px;
  height: 2px;
  border-radius: 1px;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  position: absolute;
  top: 7px;
  left: 4px;
  content: "";
}
.icon-plus:before {
  background-color: #fff;
  width: 2px;
  height: 8px;
  border-radius: 1px;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  position: absolute;
  top: 4px;
  left: 7px;
  content: "";
}

.check {
  display: inline-block;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  height: 18px;
  width: 9px;
  border-bottom: 3px solid black;
  border-right: 3px solid black;
}
</style>

<script>
import LMA from "../assets/Microservices/LMAClient.superagent";
import routes from "../assets/Microservices/Routes/BIRoutes";
import loading from "../assets/js/loading/";
import swal from "../assets/js/alerts/";
import portalEmpresa from "../components/PortalEmpresas";
import filtroAnoMes from "../components/AnoMes";
import store from "../store";
import { GChart } from "vue-google-charts";
import bsn from "bootstrap.native/dist/bootstrap-native-v4";

export default {
  name: "TelaIndicadores",
  props: [],
  components: {
    portalEmpresa,
    filtroAnoMes,
    GChart
  },
  data() {
    return {
      DadosFiltro: {
        VisualizarApenasKPIComMetas: false,
        Data: null,
        DadosSelecionadosPortalEmpresa: {
          empresas: [],
          portais: []
        },
        RangeDatas: null
      },
      DadosRelatorios: {
        Cubos: [],
        Dias: []
      },
      DadosPortalEmpresa: [],
      DadosGrafico: {
        chartData: null,
        chartOptions: null,
        chartEventsGrafico: {
          click: target => {
            this.removerLinhaGrafico(target);
          }
        },
        TitleModalGrafico: ""
      },
      modais: {
        ModalGraficoKpi: null
      },
      chart: null,
      columns: [
        {
          label: "Dias"
        },
        {
          label: "Meta"
        },
        {
          label: "Projeção"
        },
        {
          label: "Realizado"
        }
      ]
    };
  },

  mounted: function() {
    this.buscarDadosIniciais();
    this.inicializarModalGraficoKpi();
  },

  methods: {
    onChartReady: function(chart, google) {
      this.chart = chart;
    },

    inicializarModalGraficoKpi: function() {
      var myModal = document.getElementById("modalGraficoKpi");
      this.modais.ModalGraficoKpi = new bsn.Modal(myModal, {
        backdrop: "static",
        keyboard: false
      });
    },
    formataData: function(pData) {
      return (
        ("0" + pData.getDate()).slice(-2) +
        "/" +
        ("0" + (pData.getMonth() + 1)).slice(-2) +
        "/" +
        pData.getFullYear()
      );
    },
    titleDiaSemana: function(idx) {
      return (
        ("0" + idx).slice(-2) +
        "/" +
        ("0" + (this.DadosFiltro.RangeDatas.dataInicial.getMonth() + 1)).slice(
          -2
        ) +
        "/" +
        this.DadosFiltro.RangeDatas.dataInicial.getFullYear()
      );
    },
    buscarDadosIniciais: function() {
      this.DadosPortalEmpresa = store.getters.getFiltrosGlobais().FiltroPortalEmpresa;
    },
    adicionarRemoverDashboard: function(kpi) {
      var self = this;

      var dadosEnvioAPI = {
        Id: kpi.Id,
        Name: kpi.Name,
        Cube: kpi.Cube,
        Pinned: true
      };

      var rotaKPI = routes.KPI.AdicionarKPIDashboard;
      if (kpi.JaAdicionadoAoDashboard) rotaKPI = routes.KPI.RemoverKPIDashboard;

      loading.exibir();
      LMA.post(
        rotaKPI,
        dadosEnvioAPI,
        function(response) {
          var retorno = JSON.parse(response);
          kpi.JaAdicionadoAoDashboard = !kpi.JaAdicionadoAoDashboard;

          swal.exibirMensagemSucesso(
            "KPI " +
              (kpi.JaAdicionadoAoDashboard ? "adicionado" : "removido") +
              " com sucesso!",
            null,
            true
          );
          loading.ocultar();
        },
        swal.exibirMensagemValidacaoApi,
        swal.exibirMensagemErroApi
      );
    },
    filtrarCuboKPI: function() {
      var self = this;

      if (!this.validarDadosFiltrar()) return;

      var dadosEnvioAPI = {
        Portais: this.DadosFiltro.DadosSelecionadosPortalEmpresa.portais.map(
          function(portal) {
            return portal.Id.toString();
          }
        ),
        Empresas: this.DadosFiltro.DadosSelecionadosPortalEmpresa.empresas.map(
          function(emp) {
            return emp.Nome.toString();
          }
        ),
        DataInicial: this.DadosFiltro.RangeDatas.dataInicial
      };

      var empresas = this.DadosPortalEmpresa.map(x => x.Empresas.length);
      var totalEmpresas = empresas.reduce((a, b) => a + b, 0);

      if (totalEmpresas == this.DadosFiltro.DadosSelecionadosPortalEmpresa.empresas.length) {
        dadosEnvioAPI.Empresas = [];
        dadosEnvioAPI.Portais = [];
      }

      loading.exibir();
      LMA.post(
        routes.BI.ObterIndicadoresKPI,
        dadosEnvioAPI,
        function(response) {
          self.DadosRelatorios = JSON.parse(response);
          self.mapearListagem();
          loading.ocultar();
        },
        swal.exibirMensagemValidacaoApi,
        swal.exibirMensagemErroApi
      );
    },

    validarDadosFiltrar: function() {
      if (
        this.DadosFiltro.DadosSelecionadosPortalEmpresa.portais.length === 0
      ) {
        swal.exibirMensagemAlerta("Por favor, informe o campo Portais");
        return false;
      }

      if (
        this.DadosFiltro.DadosSelecionadosPortalEmpresa.empresas.length === 0
      ) {
        swal.exibirMensagemAlerta("Por favor, informe o campo Empresas");
        return false;
      }
      return true;
    },

    montaNewData: function(dia) {
      var yy = this.DadosFiltro.RangeDatas.dataInicial.getFullYear();
      var mm = this.DadosFiltro.RangeDatas.dataInicial.getMonth();
      return new Date(yy, mm, dia, 1, 0, 0, 0);
    },

    criarClassDotStatus: function(kpi, dia) {
      var dd = this.montaNewData(dia);

      var imagem = "";
      if (kpi.Status == "1") {
        imagem = "dot dot-verde";
      } else if (kpi.Status == "0") {
        imagem = "dot dot-amarelo";
      } else if (kpi.Status == "-1") {
        //imagem = "dot dot-vermelho";
        imagem = "check";
      } else if (kpi.Status == "97") {
        imagem = "naoTemBola";
      } else if (kpi.Status == "98") {
        if (dd < new Date()) imagem = "dot dot-preto";
        else imagem = "naoTemBola";
      } else if (kpi.Status == "99") {
        if (dd < new Date()) imagem = "naoTemBola";
        else
          kpi.IconCheck =
            '<span class="checkmark"><div class="checkmark_circle"></div><div class="checkmark_stem"></div><div class="checkmark_kick"></div></span>';
      }

      return imagem;
    },

    mapearListagem: function() {
      for (var i = 0; i < this.DadosRelatorios.Cubos.length; i++) {
        for (
          var j = 0;
          j < this.DadosRelatorios.Cubos[i].listaKpis.length;
          j++
        ) {
          var kpis = this.DadosRelatorios.Cubos[i].listaKpis[j];

          if (!this.DadosFiltro.VisualizarApenasKPIComMetas)
            kpis[0].VisualizarApenasKPIComMetas = true;
          else kpis[0].VisualizarApenasKPIComMetas = false;

          var totalMeta = 0;
          var totalRealizado = 0;
          var diasFeitos = 0;
          var diasMetas = 0;
          var percent = "";

          for (let dia = 0; dia < this.DadosRelatorios.Dias.length; dia++) {
            const element = kpis[dia];

            var diaLoop = this.montaNewData(dia + 1);

            var kpiGoal = element.Status == 97 || element.Status == 98 || element.Goal == "----" ? 0 : element.Goal;
            if (kpiGoal != 0 && kpiGoal != "") {
              totalMeta += this.formatarValor(kpiGoal); //parseFloat(kpiGoal.replace(".", "").replace(",", "."));
              diasMetas++;
            }

            var kpiValue = element.Status == 97 || element.Status == 99 ? 0 : element.Value;
            if (kpiValue != 0 && kpiValue != "") {
              totalRealizado += this.formatarValor(kpiValue); //parseFloat(kpiValue.replace(".", "").replace(",", "."));
              diasFeitos++;
            }

            if (element.Value.indexOf("%") > -1) {
              percent = "%";
            }

            var texto =
              "<b>" +
              element.Name +
              "</b> (" +
              this.formataData(diaLoop) +
              ")" +
              "<br /><b>Meta:</b> " +
              (element.Status == 97 ||
              element.Status == 98 ||
              element.Goal == "----"
                ? "N/A"
                : element.Goal) +
              (element.Projecao == null
                ? ""
                : "<br /><b>Projeção:</b> " +
                  (element.Status == 97 ||
                  element.Status == 98 ||
                  element.Projecao == "----"
                    ? "N/A"
                    : element.Projecao)) +
              "<br /><b>Realizado:</b> " +
              (element.Status == 97 || element.Status == 99
                ? "N/A"
                : element.Value);

            element.ClassComBola = this.criarClassDotStatus(element, dia + 1);
            element.TitleDiaSemana = texto;

            if (
              !(
                element.Status == 97 ||
                element.Status == 98 ||
                element.Goal === "----"
              )
            )
              kpis[0].VisualizarApenasKPIComMetas = true;
          }

          if (
            kpis[0].Name == "CF - Perc Consumidor Final" ||
            kpis[0].Name == "PA - Peças Atendimento" ||
            kpis[0].Name == "TC - Taxa de Conversão" ||
            kpis[0].Name == "TV - Taxa de Vazão" ||
            kpis[0].Name == "CI - Clientes Identificados" ||
            kpis[0].Name == "RT - Perc Rotatividade" ||
            kpis[0].Name == "MKP - Markup" ||
            kpis[0].Name == "VA - Ticket Médio" ||
            kpis[0].Name == "VV - Perc Vendas à Vista" ||
            kpis[0].Name == "CO - Conversão Orçamentária" ||
            kpis[0].Name == "IDE - Índice de Devolução" ||
            kpis[0].Name == "MKPP - Markup Praticado" ||
            kpis[0].Name == "TE - Taxa Equilíbrio" ||
            kpis[0].Name == "TV - Taxa de Vazão" ||
            kpis[0].Name == "VV - Perc Vendas à Vista" ||
            kpis[0].Name == "GI - Giro"
          ) {
            diasMetas = diasMetas == 0 ? 1 : diasMetas;
            diasFeitos = diasFeitos == 0 ? 1 : diasFeitos;
            totalMeta = totalMeta / diasMetas;
            totalRealizado = totalRealizado / diasFeitos;
          }

          // No KPI "QE - Quantidade Estoque", considera o valor do último dia
          if (kpis[0].Name == "QE - Quantidade Estoque") {
            totalMeta = 0;
            totalRealizado = 0;

            for (let kLoop = this.DadosRelatorios.Dias.length - 1; kLoop >= 0; kLoop--) {
              const kElementLoop = kpis[kLoop];

              if (kElementLoop.Value !== "----") {
                //totalMeta = kElementLoop.Goal.replace(".", "").replace(",", ".");

                var kpiLoopGoal = kElementLoop.Goal.replace(".", "").replace(",", ".");
                if (kpiLoopGoal != 0 && kpiLoopGoal != "")
                  totalMeta += this.formatarValor(kpiLoopGoal);

                var kpiLoopValue = kElementLoop.Value.replace(".", "").replace(",", ".");
                if (kpiLoopValue != 0 && kpiLoopValue != "")
                  totalRealizado += this.formatarValor(kpiLoopValue);

                break;
              }
            }
          }

          //Variável para metas que tem o % invertido (se realizado menor que a meta, melhor)
          var invertido = false;
          if (kpis[0].Name == "CF - Perc Consumidor Final" || kpis[0].Name == "IDE - Índice de Devolução" || kpis[0].Name == "VD - Valor Desconto") {
            invertido = true;
          }

          var textoTot =
            "<b>" + kpis[0].Name + "</b>" +
            "<br/>" +
            "<b>Meta:</b> " + this.mascararValorMonetario(totalMeta, false) + percent +
            "<br/>" +
            "<b>Realizado:</b> " + this.mascararValorMonetario(totalRealizado, false) + percent;

          var imagemTot = "";
          if (totalMeta == 0) imagemTot = "dot dot-preto";
          else if (totalRealizado >= totalMeta) {
            if (invertido) {
              imagemTot = "dot dot-vermelho";
            } else {
              imagemTot = "dot dot-verde";
            }
          } else if (invertido) {
            if (totalRealizado >= totalMeta * 1.2) {
              imagemTot = "dot dot-vermelho";
            } else {
              imagemTot = "dot dot-amarelo";
            }
          } else if (totalRealizado >= totalMeta * 0.8) {
            imagemTot = "dot dot-amarelo";
          } else {
            imagemTot = "dot dot-vermelho";
          }

          kpis.ClassComBolaTotalizador = imagemTot;
          kpis.TitleDiaSemanaTotalizador = textoTot;
        }
      }
    },
    formatarValor: function(valor) {
      //valor = valor.replace(/\./gi, "");
      //valor = valor.replace(/%/gi, "");
      //valor = valor.replace(/ /gi, "");
      //valor = valor.replace(/,/gi, ".");

      if (typeof valor === "number")
        valor = valor.toString();

      if (valor.indexOf("(") >= 0) {
        valor = valor.replace(/\(/gi, "");
        valor = valor.replace(/\)/gi, "");
        valor = "-" + valor;
      }

      valor = parseFloat(valor.replace(",", "."));

      return valor;
    },
    abrirModalGrafico: function(kpisSelecionado) {
      var self = this;

      self.DadosGrafico.TitleModalGrafico = kpisSelecionado[0].Name;

      var dadosEnvioAPI = {
        Portais: this.DadosFiltro.DadosSelecionadosPortalEmpresa.portais.map(
          function(portal) {
            return portal.Id.toString();
          }
        ),
        Empresas: this.DadosFiltro.DadosSelecionadosPortalEmpresa.empresas.map(
          function(emp) {
            return emp.Nome.toString();
          }
        ),
        DataInicial: this.DadosFiltro.RangeDatas.dataInicial,
        NomeCubo: kpisSelecionado[0].Cube,
        NomeKpi: kpisSelecionado[0].Name
      };

      loading.exibir();
      LMA.post(
        routes.BI.ObterIndicadoresKPIsGrafico,
        dadosEnvioAPI,
        function(response) {
          var mesesKpi = JSON.parse(response);
          self.carregarGraficoKpi(kpisSelecionado, mesesKpi);
          loading.ocultar();
        },
        swal.exibirMensagemValidacaoApi,
        swal.exibirMensagemErroApi
      );
    },
    carregarGraficoKpi: function(kpisSelecionados, mesesKpi) {
      var kpi = kpisSelecionados[0];
      var yy = this.DadosFiltro.RangeDatas.dataInicial.getFullYear();
      var mm = this.DadosFiltro.RangeDatas.dataInicial.getMonth();

      var metas = [];
      var realizados = [];
      var projecoes = [];
      var meses = [];
      var meta_soma = 0.0;
      var valor_soma = 0.0;
      var proj_soma = 0.0;

      var porcentagem = false;
      var media = false;
      var formato = "";
      var dia = 0;

      var columns = [];
      columns.push(["Dias", "Meta", "Projeção", "Realizado"]);

      for (dia = 0; dia < this.DadosRelatorios.Dias.length; dia++) {
        const elementKpiDia = kpisSelecionados[dia];

        if (elementKpiDia.Value.search("%") != -1) {
          porcentagem = true;
          media = true;
        }
        if (elementKpiDia.Projecao != null) {
          if (elementKpiDia.Projecao.search("%") != -1) {
            porcentagem = true;
            media = true;
          }
        }

        if (elementKpiDia.Goal != null) {
          if (elementKpiDia.Goal.search("%") != -1) {
            porcentagem = true;
            media = true;
          }
        }

        if (elementKpiDia.TipoCalculo == "AVG") {
          media = true;
        }
        formato = elementKpiDia.formato;
      }

      var dia_limite = 33;
      var data_atual = new Date();
      if (
        data_atual.getMonth() + 1 == parseInt(mm + 1) &&
        data_atual.getFullYear() == parseInt(yy)
      ) {
        dia_limite = data_atual.getDate();
      } else if (
        (data_atual.getMonth() + 1 < parseInt(mm + 1) &&
          data_atual.getFullYear() <= parseInt(yy)) ||
        data_atual.getFullYear() < parseInt(yy)
      ) {
        dia_limite = 0;
      }

      for (dia = 0; dia < this.DadosRelatorios.Dias.length; dia++) {
        const elementDiaKpi = kpisSelecionados[dia];

        if (!media) {
          //não soma, sempre será a meta do proprio dia
          meta_soma = 0;
          valor_soma = 0;
          proj_soma = 0;
        }

        var meta = elementDiaKpi.Goal == "----" ? "0" : elementDiaKpi.Goal;
        var proj =
          elementDiaKpi.Projecao == "----" ||
          elementDiaKpi.Projecao == null ||
          elementDiaKpi.Projecao == ""
            ? "0"
            : elementDiaKpi.Projecao;
        var valor = elementDiaKpi.Value;

        meta = meta.replace(/\./gi, "");
        meta = meta.replace(/%/gi, "");
        meta = meta.replace(/ /gi, "");
        meta = meta.replace(/,/gi, ".");

        proj = proj.replace(/\./gi, "");
        proj = proj.replace(/%/gi, "");
        proj = proj.replace(/ /gi, "");
        proj = proj.replace(/,/gi, ".");

        if (meta.indexOf("(") >= 0) {
          meta = meta.replace(/\(/gi, "");
          meta = meta.replace(/\)/gi, "");
          meta = "-" + meta;
        }

        if (proj.indexOf("(") >= 0) {
          proj = proj.replace(/\(/gi, "");
          proj = proj.replace(/\)/gi, "");
          proj = "-" + proj;
        }

        meta = parseFloat(meta);
        proj = parseFloat(proj);
        if (!isNaN(meta)) meta_soma += meta;

        if (!isNaN(proj)) proj_soma += proj;

        metas.push(meta_soma);
        projecoes.push(proj_soma);

        valor = valor.replace(/\./gi, "");
        valor = valor.replace(/%/gi, "");
        valor = valor.replace(/ /gi, "");
        valor = valor.replace(/,/gi, ".");

        if (valor.indexOf("(") >= 0) {
          valor = valor.replace(/\(/gi, "");
          valor = valor.replace(/\)/gi, "");
          valor = "-" + valor;
        }

        valor = parseFloat(valor);
        if (!isNaN(valor)) valor_soma += valor;

        if (dia_limite > dia) realizados.push(parseFloat(valor_soma));
      }

      for (let prop in mesesKpi) {
        if (prop.length >= 3 && prop.indexOf("$") < 0)
          columns[0].push(prop.toString());
      }

      for (let loop = 0; loop < this.DadosRelatorios.Dias.length; loop++) {
        columns.push([
          (loop + 1).toString(),
          metas[loop],
          projecoes[loop],
          realizados[loop]
        ]);
      }

      for (
        let headerDoGrafico = 0;
        headerDoGrafico < columns[0].length - 3;
        headerDoGrafico++
      ) {
        let result = Object.getOwnPropertyNames(mesesKpi)[headerDoGrafico];

        if (result.length < 4 && result.indexOf("$") >= 0) continue;

        for (
          let contador = 0;
          contador < this.DadosRelatorios.Dias.length;
          contador++
        ) {
          let valorMesCorrente = mesesKpi[result][contador].Value;
          if (valorMesCorrente) {
            valorMesCorrente = valorMesCorrente.replace(/\./gi, "");
            valorMesCorrente = valorMesCorrente.replace(/%/gi, "");
            valorMesCorrente = valorMesCorrente.replace(/ /gi, "");
            valorMesCorrente = valorMesCorrente.replace(/,/gi, ".");

            if (valorMesCorrente.indexOf("(") >= 0) {
              valorMesCorrente = valorMesCorrente.replace(/\(/gi, "");
              valorMesCorrente = valorMesCorrente.replace(/\)/gi, "");
              valorMesCorrente = "-" + valorMesCorrente;
            }

            valorMesCorrente = parseFloat(valorMesCorrente);
            if (isNaN(valorMesCorrente)) valorMesCorrente = 0;
          } else valorMesCorrente = 0;

          // Inicia no 1 pois o primeiro é o cabeçalho/serie do grafico
          columns[1 + contador].push(valorMesCorrente);
        }
      }

      this.DadosGrafico.chartData = columns;

      var seriesModificada = {};
      for (let index = 0; index < columns[0].length; index++) {
        let colorRandom = this.getRandomColor();

        seriesModificada[index] = {
          targetAxisIndex: 0,
          visibleInLegend: 1,
          color: index <= 2 ? colorRandom : "transparent",
          disabledColor: "transparent",
          enableColor: colorRandom,
          visible: index <= 2 ? 1 : 0
        };
      }

      this.DadosGrafico.chartOptions = {
        title: kpi.Name,
        width: 1000,
        height: 500,
        series: seriesModificada,
        vAxes: {
          0: { title: "Valores" }
        },
        hAxes: {
          0: { title: "Dias" }
        },
        hAxis: {
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          textStyle: {
            fontSize: 12
          }
        }
      };

      this.modais.ModalGraficoKpi.show();
    },
    removerLinhaGrafico: function(target) {
      if (target.targetID.match(/^legendentry#\d+$/)) {
        var index = parseInt(target.targetID.slice(12));
        this.DadosGrafico.chartOptions.series[index].visible = !this
          .DadosGrafico.chartOptions.series[index].visible;
        this.DadosGrafico.chartOptions.series[index].color = this.DadosGrafico
          .chartOptions.series[index].visible
          ? this.DadosGrafico.chartOptions.series[index].enableColor
          : this.DadosGrafico.chartOptions.series[index].disabledColor;
        this.chart.draw();
      }
    },
    getRandomColor: function() {
      var letters = "0123456789ABCDEF";
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    mascararValorMonetario: function (valor, comSimboloRS) {
      valor = valor.toString();
      if (valor.indexOf(","))
        valor = valor.replace(",", ".");

      return comSimboloRS ? "R$" : "" + new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(parseFloat(valor));
    }
  }
};
</script>
